// ═══ 검차 셸 (A0) — simpleActive 사용자의 /main/* 를 대체한다 (신고 371) ═══
// 단 차량관리 허용 경로(routes.isManagePath)는 Dashboard 래퍼가 이 셸 대신 크롬 변형(SimpleChrome + 기존 ERP 화면)으로 연다.
// ≥1024: 상단 앱바(로고 · 4탭 · 회사 드롭다운 — '더보기' 는 드롭다운이 흡수, §8 결정 3)
// 769~1023: 상단 앱바(로고 · 5탭 · 언어 · 회사) / ≤768: 얇은 상단 바 + 하단 고정 5탭.
// RTL 은 **이 컨테이너 스코프** — I18nProvider 의 전역 <html dir> 은 경매 바이어 도메인 전용.
// props: { user, onLogout, screenMode }
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useT, useLocale } from '../../i18n/I18nProvider';
import { useIsMobile } from '../../utils/useMobile';
import { useIsDesktop } from './useDesktop';
import { getSocket } from '../../utils/socket';
import { putLocale } from './api';
import SimpleRoutes, { SIMPLE_TABS, tabIdOf } from './routes';
import AssistantWidget from '../../components/AssistantWidget';
import BugReportButton from '../../components/BugReportButton';
import BottomTabs from './parts/BottomTabs';
import SimpleAppBar from './parts/SimpleAppBar';
import './simple.css';

function SimpleShell(props) {
  var t = useT();
  var loc = useLocale();
  var isMobile = useIsMobile();
  var isDesktop = useIsDesktop();
  var navigate = useNavigate();
  var location = useLocation();

  // 회사 room 실시간 이벤트를 화면이 듣기 쉬운 CustomEvent 로 재발행한다 —
  // 화면(목록·홈)은 window 의 'autodex:eval-updated' 만 구독하면 된다(소켓 배선 중복 금지).
  useEffect(function () {
    var sock = null;
    try { sock = getSocket(); } catch (e) { sock = null; }
    if (!sock) return undefined;
    var relay = function (payload) {
      try { window.dispatchEvent(new CustomEvent('autodex:eval-updated', { detail: payload || null })); } catch (e) { /* 구형 브라우저 */ }
    };
    sock.on('eval:updated', relay);
    sock.on('eval:completed', relay);
    return function () {
      try { sock.off('eval:updated', relay); sock.off('eval:completed', relay); } catch (e) { /* 이미 끊김 */ }
    };
  }, []);

  // 마운트 시 + 언어 변경 시 서버에 저장(BUILD_PLAN §2.4·§6) — 실패는 putLocale 내부에서 무시.
  useEffect(function () { putLocale(loc.locale); }, [loc.locale]);

  var activeTab = tabIdOf(location.pathname);
  // 데스크톱은 '더보기' 를 회사명 드롭다운으로 옮긴다 — /main/s/more 라우트는 직접 진입용으로 남는다.
  var tabs = SIMPLE_TABS.filter(function (tab) {
    return !(isDesktop && tab.id === 'more');
  }).map(function (tab) {
    return { id: tab.id, label: t(tab.labelKey), onClick: function () { navigate(tab.to); } };
  });

  // 오류 신고 창 — 이 셸엔 상단 신고 버튼이 없고, AI도우미 [문의 남기기] 가 이 창을 연다 (Jin 10/22).
  var _toast = useState(null); var toast = _toast[0]; var setToast = _toast[1];
  var showToast = function (msg, type) { setToast({ msg: msg, type: type }); setTimeout(function () { setToast(null); }, 2000); };

  // AI 에이전트 위젯 — 일반 화면(Dashboard.js)과 같은 인스턴스. 노출은 위젯이 /assistant/config 로 스스로 게이트.
  // RTL 컨테이너 밖 형제로 둔다(SimpleChrome 경로의 DashboardFull 도 .dash-main 밖). 차량관리 크롬 경로는 DashboardFull 이 따로 띄우므로 화면당 1개.
  return (<><div className="simple-shell" dir={loc.locale === 'ar' ? 'rtl' : 'ltr'} lang={loc.locale}>
    <SimpleAppBar user={props.user} screenMode={props.screenMode} onLogout={props.onLogout}
      tabs={tabs} activeTab={activeTab} isMobile={isMobile} isDesktop={isDesktop} />

    <main className="ss-page">
      <div className="ss-inner">
        <SimpleRoutes user={props.user} screenMode={props.screenMode} onLogout={props.onLogout} />
      </div>
    </main>

    {isMobile ? <BottomTabs items={tabs} activeId={activeTab} /> : null}
  </div>
  <BugReportButton user={props.user} showToast={showToast} />
  {toast ? <div className={'ss-toast' + (toast.type === 'err' ? ' ss-toast-err' : '')} role="status">{toast.msg}</div> : null}
  <AssistantWidget user={props.user} screenMode={true} /></>);
}

export default SimpleShell;
